import React, { useEffect, useState } from "react";
import {
  Typography,
  Grid2,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { Icons } from "../../../config/MuiIcons.config";
import AppInputField from "../../../components/CommonReusableComponent/AppInputField/AppInputField";
import AppButton from "../../../components/CommonReusableComponent/AppButton/AppButton";
import MUIErrorText from "../../../components/MUIErrorText/MUIErrorText";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  createUser,
  getAllDepartmentListByBranchId,
  // getAllRoles,
  updateUser,
} from "../../../helpers/api-functions-helper";
import { useSnackbar } from "../../../contexts/Snackbar.context";
import { useBackdrop } from "../../../contexts/BackDrop.context"
import {
  APP_MESSAGE,
  SNACKBAR_VARIANT,
  ERROR_MESSAGE,
  USE_FORMIK_SCHEMA,
  FORM_VALIDATIONS,
} from "../../../config/Messages.config";
import AppAutoCompleteField from "../../../components/CommonReusableComponent/AppAutoCompleteField/AppAutoCompleteField";
import {
  checkDuplicateEntity,
  getDataForAllOption,
  replaceTextToCaplitalize,
  setRequiredDataForDropdown,
  validateEmailField,
} from "../../../common/CommonFunctions";
import { useMediaQuery } from "@mui/material";
import CountryCodeDropdown from "../../../components/CommonReusableComponent/CountryCodeDropdown/CountryCodeDropdown";
import { getUserRoleAndScreens } from "../../../services/authServices/auth.services";
import { ROLES, rolesForUserMaster } from "../../../config/Roles.config";


const CreateNewOrUpdateUserModal = ({
  Open,
  ToggleDialogBox,
  Title,
  DialogData,
  SetDialogData,
  FetchAllUserOfPlant,
  ListOfAllPlants,
  PlantId,
  AllUserNames,
}) => {
  const { showSnackbar } = useSnackbar();
  const { showBackdrop, hideBackdrop } = useBackdrop();
  const { accountId, role } = getUserRoleAndScreens();
  // eslint-disable-next-line no-unused-vars
  let isMobileDevice = useMediaQuery("(max-width:500px)");
  const isUpdateMode = DialogData && DialogData?.id;
  const [isCreateOrUpdateClicked, setIsCreateOrUpdateClicked] = useState(false);
  const authUser = JSON.parse(
    localStorage.getItem(process.env.REACT_APP_DEV_AUTH_USER)
  );

  // departments
  const [departments, setDepartments] = useState([]);

  // Function used to create new role
  const createNewUser = (data) => {
    setIsCreateOrUpdateClicked(true);
    createUser(data)
      .then((res) => {
        if (res && res.data) {
          const { statusCode, success, message, data } = res.data;
          if (!success && statusCode === 400) {
            showSnackbar(
              data || message || APP_MESSAGE.USER_MASTER.CREATE.FAILED,
              SNACKBAR_VARIANT.ERROR
            );
          } else {
            showSnackbar(
              APP_MESSAGE.USER_MASTER.CREATE.SUCCESS,
              SNACKBAR_VARIANT.SUCCESS
            );
            handleResetDialogBox();
            if (PlantId !== null) {
              FetchAllUserOfPlant(PlantId);
            }
          }
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        showSnackbar(
          APP_MESSAGE.USER_MASTER.CREATE.FAILED,
          SNACKBAR_VARIANT.ERROR
        );
      })
      .finally(() => {
        setIsCreateOrUpdateClicked(false);
      });
  };

  // Function used to update existing role
  const updateExistingUser = (data) => {
    setIsCreateOrUpdateClicked(true);
    updateUser(data)
      .then((res) => {
        if (res && res.data) {
          const { statusCode, success, data, message } = res.data;
          if (!success && statusCode !== 200) {
            showSnackbar(
              data || message || APP_MESSAGE.USER_MASTER.UPDATE.FAILED,
              SNACKBAR_VARIANT.ERROR
            );
          } else {
            showSnackbar(
              APP_MESSAGE.USER_MASTER.UPDATE.SUCCESS,
              SNACKBAR_VARIANT.SUCCESS
            );
            handleResetDialogBox();
            if (PlantId !== null) {
              FetchAllUserOfPlant(PlantId);
            }
          }
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        showSnackbar(
          APP_MESSAGE.USER_MASTER.UPDATE.FAILED,
          SNACKBAR_VARIANT.ERROR
        );
      })
      .finally(() => {
        setIsCreateOrUpdateClicked(false);
      });
  };

  // Fetch all departments under branch
  const fetchAllDepartmentsOfBranch = (branchId) => {
    const payload = {
      branchIds: getDataForAllOption("branch", branchId, ListOfAllPlants),
      accountId: accountId,
    };
    showBackdrop();
    getAllDepartmentListByBranchId(payload)
      .then((response) => {
        if (response && response.data) {
          const { statusCode, data } = response.data;
          if (statusCode && statusCode === 200) {
            setRequiredDataForDropdown(setDepartments, data, "name", "id");
          } else {
            setDepartments([]);
          }
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        showSnackbar(
          ERROR_MESSAGE.FAILED_TO_FETCH_DATA,
          SNACKBAR_VARIANT.ERROR
        );
      })
      .finally(() => {
        hideBackdrop();
      });
  };

  // Formik form validation
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      userName: (DialogData && DialogData.userName) || "",
      phoneNumber: (DialogData && DialogData.phoneNumber) || "",
      email: (DialogData && DialogData.email) || "",
      roleName: (DialogData && DialogData.roleName) || "",
      assignedBranches: (DialogData && DialogData.assignedBranches[0].id) || "",
      assignedDepartments:
        (DialogData && DialogData.assignedBranches[0].assignedDepartments) || [],
      phoneNumberContryCode:
        (DialogData && DialogData.phoneNumberContryCode) || "91",
    },
    validationSchema: Yup.object({
      userName: Yup.string()
        .trim()
        .matches(
          /^[A-Za-z ]+$/,
          FORM_VALIDATIONS.TEXT_INPUT.MESAAGE.INITIAL
        )
        .required(USE_FORMIK_SCHEMA.USER_MASTER.USER_NAME),
      phoneNumber: Yup.string()
        .matches(
          FORM_VALIDATIONS.NUMBER_INPUT.REGEX,
          FORM_VALIDATIONS.NUMBER_INPUT.MESAAGE
        )
        .required(USE_FORMIK_SCHEMA.USER_MASTER.PHONE_NUMBER),
      email: Yup.string()
        // .required(USE_FORMIK_SCHEMA.USER_MASTER.EMAIL)
        // .email(USE_FORMIK_SCHEMA.USER_MASTER.EMAIL),
        .required(FORM_VALIDATIONS.EMAIL.REQUIRED)
        .test("email-validation", "Invalid email", function (value) {
          if (!value) {
            return this.createError({ message: "Email is required" });
          }
          const validationMessage = validateEmailField(value);
          return validationMessage === true
            ? true
            : this.createError({ message: validationMessage });
        }),
      roleName: Yup.string().required(USE_FORMIK_SCHEMA.USER_MASTER.ROLE),
      phoneNumberContryCode: Yup.string().required(
        USE_FORMIK_SCHEMA.USER_MASTER.COUNTRY_CODE
      ),
      // assignedBranches: Yup.array(USE_FORMIK_SCHEMA.USER_MASTER.PLANT)
      //   .of(Yup.object().required(USE_FORMIK_SCHEMA.USER_MASTER.PLANT))
      //   .min(1, USE_FORMIK_SCHEMA.USER_MASTER.PLANT)
      //   .required(USE_FORMIK_SCHEMA.USER_MASTER.PLANT),
      assignedBranches: Yup.string().required(
        USE_FORMIK_SCHEMA.USER_MASTER.PLANT
      ),
      // assignedDepartments: Yup.array(USE_FORMIK_SCHEMA.USER_MASTER.DEPT)
      //   .of(Yup.object().required(USE_FORMIK_SCHEMA.USER_MASTER.DEPT))
      //   .min(1, USE_FORMIK_SCHEMA.USER_MASTER.DEPT)
      //   .required(USE_FORMIK_SCHEMA.USER_MASTER.DEPT),
      assignedDepartments: Yup.array()
        .when("roleName", { // Replace "roleName" with the actual field that controls this condition
          is: (role) => role !== ROLES.ADMIN, // Apply validation only if role is not "Admin"
          then: (schema_) => 
            schema_
              .of(Yup.object().required(USE_FORMIK_SCHEMA.USER_MASTER.DEPT))
              .min(1, USE_FORMIK_SCHEMA.USER_MASTER.DEPT)
              .required(USE_FORMIK_SCHEMA.USER_MASTER.DEPT),
          otherwise: (schema_) => schema_.notRequired(),
        }),  
    }),
    onSubmit: (values) => {
      // console.log("values: ", values);
      const { assignedBranches } = values;
      const getAssignedBranch = ListOfAllPlants?.filter(
        (branch) => branch.value === assignedBranches
      ).map((res) => {
        return {
          name: res.label,
          id: res.value,
          isActive: res.isActive,
        };
      });

      if (DialogData && DialogData.userName) {
        const { email, assignedBranches, assignedDepartments, ...rest } = { ...values };
        const update_payload = {
          ...rest,
          assignedBranches: [{
            ...getAssignedBranch[0],
            assignedDepartments: [...assignedDepartments]
          }],
          id: DialogData?.id,
          updatedBy: authUser?.uid,
        };
        console.log("update_payload: ", update_payload);
        updateExistingUser(update_payload);
      } else {
        if (checkDuplicateEntity(AllUserNames, values.userName)) {
          showSnackbar(
            APP_MESSAGE.USER_MASTER.DUPLICATE_USER_NAME,
            SNACKBAR_VARIANT.ERROR
          );
        } else {
          const { assignedBranches, assignedDepartments, ...rest } = values
          // console.log("getAssignedBranch: ", getAssignedBranch)
          const create_payload = {
            ...rest,
            assignedBranches: [{
              ...getAssignedBranch[0],
              assignedDepartments: [...assignedDepartments]
            }],
            userName: replaceTextToCaplitalize(values.userName.trim()),
            createdBy: authUser?.uid,
            updatedBy: authUser?.uid,
            accountId: accountId,
          }
          console.log("create_payload: ", create_payload)
          createNewUser(create_payload);
        }
      }
    },
  });

  // Function used reset dialog box
  function handleResetDialogBox() {
    ToggleDialogBox("Create/Update");
    validation.handleReset();
    SetDialogData(null);
  }

  // Function used handle onChange department selection
  const handleAssignedDept = (event, value) => {
    const dept = value
      .map((item) => ({
        id: item.value,
        name: item.label,
      }))
      .filter(
        (dept_, index, self) =>
          index === self.findIndex((d) => d.id === dept_.id)
      );
    validation.setFieldValue("assignedDepartments", dept);
  };

  const isAdmin = role && role.toLowerCase() === "admin" ? true : false;

  const getUserRolesToAssign = () => {
    const filtedRoles = rolesForUserMaster.filter((role) => {
      if (isAdmin) {
        return role.value !== "admin";
      } else {
        return true;
      }
    });

    return filtedRoles;
  };

  // Function to get fixed branches
  const getFixedDepartments = () => {
    const fixedOptionsForBranches =
      DialogData?.id && isAdmin
        ? DialogData?.assignedBranches?.assignedDepartments?.map((dept) => ({
            label: dept.name,
            value: dept.id,
          }))
        : [];

    return fixedOptionsForBranches;
  };

  const { assignedBranches } = validation.values;

  useEffect(() => {
    if (assignedBranches) {
      fetchAllDepartmentsOfBranch(assignedBranches);
    }
  }, [assignedBranches]);

  // Function to reset formik field/states
  const resetFormikState = (fieldName, data) => {
    validation.setFieldValue(fieldName, data);
    validation.setFieldTouched(fieldName, "");
  }

  // Function to handle changes while role and branch gets updated
  const handleChangeBranchOrRole = (event) => {
    validation.handleChange(event);
    
    const { value, name } = event?.target;
    const resetFieldName = "assignedDepartments";
  
    // Determine ID to compare
    const ID_TO_COMPARE =
      name === "assignedBranches" ? value : validation.values.assignedBranches;
  
    // Check if the selected branch is the same as the previously assigned branch
    const isOldBranchSelected =
      DialogData && DialogData.assignedBranches[0].id === ID_TO_COMPARE ? true : false;
  
    // Determine assigned departments data
    const data = !DialogData
      ? name === "roleName"
        ? validation.values.assignedDepartments
        : []
      : isOldBranchSelected
      ? DialogData.assignedBranches[0].assignedDepartments
      : [];
  
    if (name === "assignedBranches") {
      resetFormikState(resetFieldName, data);
      fetchAllDepartmentsOfBranch(value);
    } else if (name === "roleName" && value.toLowerCase() === ROLES.ADMIN) {
      resetFormikState(resetFieldName, data);
    }
  };  

  return (
    <Dialog
      open={Open}
      disableEscapeKeyDown={true}
      maxWidth="md"
      disableEnforceFocus={true}
      fullWidth
      slotProps={{
        style: {
          opacity: 0.7,
        },
      }}
      // onClose={() => ToggleDialogBox("Create/Update")}
    >
      <DialogTitle id="responsive-dialog-title">
        <Typography
          className="inter-medium-500"
          style={{
            fontSize: "18px",
          }}
        >
          {Title}
        </Typography>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleResetDialogBox}
        style={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Icons.Close />
      </IconButton>
      <DialogContent dividers>
        <div>
          <Grid2 container spacing={2} className="mb-1">
            <Grid2 size={{ xs: 12, md: 4, lg: 4 }}>
              <Typography variant="body2" className="inter-regular-400 py-2">
                Select Branch
              </Typography>
              {/* <AppInputField
                Name={"assignedBranches"}
                Id={"assignedBranches"}
                IsSelect={true}
                SelectOptions={ListOfAllPlants || []}
                Disabled={isCreateOrUpdateClicked}
                Value={validation.values.assignedBranches || ""}
                OnBlur={validation.handleBlur}
                OnChange={handleChangeBranchOrRole}
                PlaceHolder={"Select branch"}
                Error={
                  validation.touched.assignedBranches &&
                  validation.errors.assignedBranches
                    ? true
                    : false
                }
                HelperText={validation.errors.assignedBranches}
              /> */}
              <AppAutoCompleteField 
                IsMultiple={false}
                TextInputName={"assignedBranches"}
                TextInputId={"assignedBranches"}
                Id={"assignedBranches"}
                TextInputPlaceholder={"Select branch"}
                Options={ListOfAllPlants?.filter(pl => pl.label !== "All") || []}
                Disabled={isCreateOrUpdateClicked}
                Value={validation.values.assignedBranches || ""}
                HandleOnBlur={validation.handleBlur}
                HandleOnChange={(event, value) => {
                  if (value?.value) {
                    const event_ = {
                      ...event,
                      target: {
                        ...event?.target,
                        value: value?.value,
                        name: "assignedBranches",
                        id: "assignedBranches"
                      }
                    }
                    handleChangeBranchOrRole(event_)
                  }
                }}
                TextInputError={
                  validation.touched.assignedBranches &&
                  validation.errors.assignedBranches
                    ? true
                    : false
                }
                TextInputHelperText={validation.errors.assignedBranches}
              />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 8, lg: 8 }}>
              <Typography variant="body2" className="inter-regular-400 py-2">
                Select Department
              </Typography>
              <AppAutoCompleteField
                Options={departments}
                FixedOptions={getFixedDepartments()}
                DisableCloseOnSelect={true}
                ChipLimit={isMobileDevice ? 1 : 6}
                Disabled={isCreateOrUpdateClicked}
                Id={"assignedDepartments"}
                Value={validation.values.assignedDepartments.map((dept) => ({
                  label: dept.name,
                  value: dept.id,
                }))}
                HandleOnChange={(event, value) =>
                  handleAssignedDept(event, value)
                }
                HandleOnBlur={validation.handleBlur}
                TextInputId={"assignedDepartments"}
                TextInputName={"assignedDepartments"}
                TextInputPlaceholder={"Select departments"}
                TextInputError={
                  validation.touched.assignedDepartments &&
                  validation.errors.assignedDepartments
                    ? true
                    : false
                }
                TextInputHelperText={
                  validation.touched.assignedDepartments &&
                  validation.errors.assignedDepartments ? (
                    <MUIErrorText
                      ErrorMessage={validation.errors.assignedDepartments}
                    />
                  ) : null
                }
              />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
              <Typography variant="body2" className="inter-regular-400 py-2">
                Name
              </Typography>
              <AppInputField
                Name={"userName"}
                Id={"userName"}
                Type={"text"}
                Disabled={isCreateOrUpdateClicked || isUpdateMode}
                Value={validation.values.userName || ""}
                OnBlur={validation.handleBlur}
                OnChange={validation.handleChange}
                IsCapitalizeRequired={true}
                // Label={"User Name *"}
                PlaceHolder={"Enter name"}
                Error={
                  validation.touched.userName && validation.errors.userName
                    ? true
                    : false
                }
                HelperText={
                  validation.touched.userName && validation.errors.userName ? (
                    <MUIErrorText ErrorMessage={validation.errors.userName} />
                  ) : null
                }
              />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 3, lg: 3 }}>
              <Typography variant="body2" className="inter-regular-400 py-2">
                Country Code
              </Typography>
              <CountryCodeDropdown
                Id={"phoneNumberContryCode"}
                Name={"phoneNumberContryCode"}
                PlaceHolder={"Country code"}
                Value={validation.values.phoneNumberContryCode || ""}
                Disabled={isCreateOrUpdateClicked}
                OnChange={validation.handleChange}
                OnBlur={validation.handleBlur}
                Error={
                  validation.touched.phoneNumberContryCode &&
                  validation.errors.phoneNumberContryCode
                    ? true
                    : false
                }
                HelperText={validation.errors.phoneNumberContryCode}
              />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 3, lg: 3 }}>
              <Typography variant="body2" className="inter-regular-400 py-2">
                Phone Number
              </Typography>
              <AppInputField
                Name={"phoneNumber"}
                Id={"phoneNumber"}
                Type={"text"}
                Disabled={isCreateOrUpdateClicked}
                Value={validation.values.phoneNumber || ""}
                OnBlur={validation.handleBlur}
                OnChange={validation.handleChange}
                // Label={"Phone Number *"}
                PlaceHolder={"Enter phone number"}
                Error={
                  validation.touched.phoneNumber &&
                  validation.errors.phoneNumber
                    ? true
                    : false
                }
                HelperText={
                  validation.touched.phoneNumber &&
                  validation.errors.phoneNumber ? (
                    <MUIErrorText
                      ErrorMessage={validation.errors.phoneNumber}
                    />
                  ) : null
                }
              />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
              <Typography variant="body2" className="inter-regular-400 py-2">
                Email ID
              </Typography>
              <AppInputField
                Name={"email"}
                Id={"email"}
                Type={"email"}
                Disabled={isCreateOrUpdateClicked || isUpdateMode}
                Value={validation.values.email || ""}
                OnBlur={validation.handleBlur}
                OnChange={(e) => {
                  const { value, name } = e.target;
                  validation.handleChange({
                    ...e,
                    target: {
                      ...e.target,
                      name: name,
                      value: value.toLowerCase(),
                    },
                  });
                }}
                // Label={"Email ID *"}
                PlaceHolder={"Enter email ID"}
                Error={
                  validation.touched.email && validation.errors.email
                    ? true
                    : false
                }
                HelperText={
                  validation.touched.email && validation.errors.email ? (
                    <MUIErrorText ErrorMessage={validation.errors.email} />
                  ) : null
                }
              />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
              <Typography variant="body2" className="inter-regular-400 py-2">
                Select Role
              </Typography>
              <AppInputField
                Name={"roleName"}
                Id={"roleName"}
                IsSelect={true}
                SelectOptions={getUserRolesToAssign() || []}
                Disabled={isCreateOrUpdateClicked}
                Value={validation.values.roleName || ""}
                OnBlur={validation.handleBlur}
                OnChange={handleChangeBranchOrRole}
                // Label={"Select Role *"}
                PlaceHolder={"Select role"}
                Error={
                  validation.touched.roleName && validation.errors.roleName
                    ? true
                    : false
                }
                HelperText={validation.errors.roleName}
              />
            </Grid2>
          </Grid2>
          <Grid2 container spacing={2} className="mt-3">
            {!isUpdateMode ? (
              <Grid2 size={{ xs: 6 }}>
                <AppButton
                  Type={"reset"}
                  IsDisabled={isCreateOrUpdateClicked}
                  OnPress={() => {
                    validation.handleReset();
                    // SetDialogData(null);
                  }}
                  children={"Reset"}
                  Color={"error"}
                />
              </Grid2>
            ) : null}
            <Grid2 size={{ xs: isUpdateMode ? 12 : 6 }}>
              <AppButton
                Type={"submit"}
                OnPress={() => {
                  if (navigator.onLine) {
                    validation.handleSubmit();
                  } else {
                    showSnackbar(
                      ERROR_MESSAGE.INTERNET_ERROR,
                      SNACKBAR_VARIANT.ERROR
                    );
                  }
                }}
                IsDisabled={isCreateOrUpdateClicked}
                LoadingState={isCreateOrUpdateClicked}
              >
                {DialogData !== null ? "Update" : "Create"}
              </AppButton>
            </Grid2>
          </Grid2>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CreateNewOrUpdateUserModal;
